import { render, staticRenderFns } from "./FormulationDangerousGoodNoteTab.vue?vue&type=template&id=77519c16&scoped=true&"
import script from "./FormulationDangerousGoodNoteTab.vue?vue&type=script&lang=js&"
export * from "./FormulationDangerousGoodNoteTab.vue?vue&type=script&lang=js&"
import style0 from "./FormulationDangerousGoodNoteTab.vue?vue&type=style&index=0&id=77519c16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77519c16",
  null
  
)

export default component.exports